import React, { useEffect } from "react";
import {
    Box,
    BoxProps,
    Button,
    Card,
    Grid,
    TextField,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import * as Styles from "pages/external/completeLogin/completeLogin.styles";
import * as userService from "services/identityUser-service";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTenantContext } from "contexts/tenantContext";

interface IProps {
    showMessage: MessageBox;
}

const CompleteLogin = (props: IProps) => {
    const { showMessage } = props;
    const { currentTenant } = useTenantContext();
    const navigate = useNavigate();
    const theme = useTheme();
    const { t } = useTranslation();
    const [searchParams, _] = useSearchParams();
    const [userId, setUserId] = React.useState<string>("");
    const [token, setToken] = React.useState<string>("");
    const [user, setUser] = React.useState<User | null>(null);
    const [error, setError] = React.useState<string>("");
    const isMobile = useMediaQuery(theme.breakpoints.between("xs", "md"));

    useEffect(() => {
        const userId = searchParams.get("user");
        const token = searchParams.get("token");
        if (userId && token) {
            setUserId(userId);
            setToken(token);
            // userService.getById(userId).then((res) => {
            //     setUser(res);
            // }).catch((err) => {
            //     navigate('/')
            // });
        } else {
            navigate("/");
        }
    }, []);

    const Content = () => {
        const SCHEMA = Yup.object({
            password: Yup.string()
                .required(t("yup.required"))
                .min(8, t("yup.min8"))
                .matches(/(?=.*[0-9])/, t("yup.number"))
                .matches(/(?=.*[a-z])/, t("yup.lowercase"))
                .matches(/(?=.*[A-Z])/, t("yup.uppercase"))
                .matches(/(?=.*[!@#$%^&*])/, t("yup.special")),
            testPassword: Yup.string()
                .required(t("yup.required"))
                .oneOf([Yup.ref("password")], t("yup.match")),
        });
        const formik = useFormik({
            initialValues: {
                password: "",
                testPassword: "",
            },
            validationSchema: SCHEMA,
            onSubmit: (values) => {},
        });

        const handleSubmit = (): void => {
            if (currentTenant !== null) {
                userService
                    .resetUserPassword({
                        id: userId as string,
                        token: token as string,
                        password: formik.values.password,
                    })
                    .then(() => {
                        navigate("/login");
                        showMessage(
                            t("completeLogin.success"),
                            "success",
                            5000,
                        );
                    })
                    .catch((err) => {
                        setError(err.message);
                    });
            }

            // userService.updateUser({
            //     email: user?.email as string,
            //     name: user?.name as string,
            //     password: formik.values.password,
            //     surName: user?.surname as string,
            //     userName: ''
            // }, userId).then((res) => {
            //     if (res.length == 0) {
            //         navigate('/login');
            //         showMessage(t('completeLogin.success'), 'success', 5000);
            //     } else {
            //         setError(res.join('\n'));
            //     }
            // });
        };

        const infoTextProps: BoxProps = {
            sx: Styles.infotext(theme),
        };

        return (
            <Box sx={Styles.containerCSS(theme)}>
                <h1>{t("completeLogin.title")}</h1>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            label={t("completeLogin.labels.password")}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.password}
                            error={
                                formik.touched.password &&
                                Boolean(formik.errors.password)
                            }
                            helperText={
                                formik.touched.password &&
                                formik.errors.password
                            }
                            fullWidth
                            type="password"
                            name="password"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            label={t(
                                "completeLogin.labels.passwordConfirmation",
                            )}
                            // value={testPassword}
                            // error={error.length > 0}
                            // helperText={error}
                            // onChange={(e) => setTestPassword(e.target.value)}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.testPassword}
                            error={
                                formik.touched.testPassword &&
                                Boolean(formik.errors.testPassword)
                            }
                            helperText={
                                formik.touched.testPassword &&
                                formik.errors.testPassword
                            }
                            fullWidth
                            type="password"
                            name="testPassword"
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sx={{
                            paddingBottom: "1.25rem",
                        }}
                    >
                        <Button
                            variant="contained"
                            onClick={handleSubmit}
                            disabled={!(formik.isValid && formik.dirty)}
                            fullWidth
                            color="primary"
                        >
                            {t("completeLogin.send")}
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        );
    };

    return (
        <Box maxWidth="lg" sx={Styles.wrapper(theme)}>
            {isMobile ? (
                <Box>
                    <Box sx={Styles.containerCSS(theme)}>
                        <h1>Complete Login</h1>
                        <Box sx={Styles.infotext(theme)}>
                            <Content />
                        </Box>
                    </Box>
                </Box>
            ) : (
                <Card sx={Styles.cardCSS(theme)}>
                    <Content />
                </Card>
            )}
        </Box>
    );
};

export default CompleteLogin;
